"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Failed = exports.InUse = exports.Stopped = exports.Prepared = exports.NotSupported = exports.NotRequested = exports.WebRtcGroup = void 0;
const state_flow_1 = require("@video/state-flow");
const player_options_1 = require("../../../../api/player-options");
const webrtc_1 = require("../../drivers/video-element/webrtc");
const state_flow_2 = require("../state-flow");
const common_1 = require("./common");
//#endregion
//#region Group Declaration
exports.WebRtcGroup = state_flow_2.PlayerStateFlow.registerGroup("webRtc").bootstrap(() => {
    return (0, exports.NotRequested)({
        driverFormat: "webrtc",
        priority: -1,
        support: "",
        timeout: 0,
        options: player_options_1.WebrtcDriverOptions.parse({ id: "webrtc" }),
        features: {
            sourceQuality: true,
            forcedQuality: false,
            autoBitrate: true,
        },
    });
});
//#endregion
//#region Signals Handlers
function loadDriver(groups, signal) {
    const [priority, options] = (0, common_1.findDriver)(webrtc_1.WebRtcDriver, signal.options.drivers);
    if (priority === -1) {
        return state_flow_1.Result.ignore();
    }
    const support = (0, common_1.checkDriverSupport)(webrtc_1.WebRtcDriver, groups.host.element, groups.manifest.json);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.webRtc, priority, support, options, timeout: options.timeout });
    }
    return (0, exports.NotSupported)({ ...groups.webRtc, priority, support, options });
}
function unloadDriver(groups, signal) {
    const [priority, _] = (0, common_1.findDriver)(webrtc_1.WebRtcDriver, signal.options.drivers);
    if (priority !== -1) {
        return state_flow_1.Result.ignore();
    }
    return (0, exports.NotRequested)({ ...groups.webRtc, priority });
}
function updateSupportHostStatus(groups, signal) {
    const support = (0, common_1.checkDriverSupport)(webrtc_1.WebRtcDriver, signal.host, groups.manifest.json);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.webRtc, support });
    }
    return (0, exports.NotSupported)({ ...groups.webRtc, support });
}
function updateSupportManifestStatus(groups, signal) {
    const support = (0, common_1.checkDriverSupport)(webrtc_1.WebRtcDriver, groups.host.element, signal.manifest);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.webRtc, support });
    }
    return (0, exports.NotSupported)({ ...groups.webRtc, support });
}
// function nativeHlsLoad({ nativeHls, manifest }: Groups, signal: Signals["nativeHlsLoad"]): StateResult<Props> {
//   const format = manifest.json?.formats[nativeHls.driverFormat];
//   if (format == null) {
//     return NotSupported({ ...nativeHls });
//   }
//
//   return Loaded({ ...nativeHls });
// }
// function requestDriver({ nativeHls }: Groups, signal: Signals["requestDriver"]): StateResult<Props> {
//   return NotSupported(nativeHls);
// }
//#endregion
//#region States Declarations
exports.NotRequested = exports.WebRtcGroup.registerState("NotRequested", {
    optionsApply: loadDriver,
});
exports.NotSupported = exports.WebRtcGroup.registerState("NotSupported", {
    optionsApply: unloadDriver,
    manifestUpdate: updateSupportManifestStatus,
    hostElementAttach: updateSupportHostStatus,
});
exports.Prepared = exports.WebRtcGroup.registerState("Prepared", {
    optionsApply: unloadDriver,
    manifestUpdate: updateSupportManifestStatus,
    hostElementAttach: updateSupportHostStatus,
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.WebRtcGroup.name ? (0, exports.InUse)(g.webRtc) : g.webRtc;
    },
});
exports.Stopped = exports.WebRtcGroup.registerState("Stopped", {
    optionsApply: unloadDriver,
    hostElementAttach: updateSupportHostStatus,
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.WebRtcGroup.name ? (0, exports.InUse)(g.webRtc) : g.webRtc;
    },
});
exports.InUse = exports.WebRtcGroup.registerState("InUse", {
    optionsApply: () => state_flow_1.Result.reject("driver is in use"),
    hostElementDetach: () => state_flow_1.Result.reject("host element is in use of WebRtc"),
    // hostElementDetach: (g) => Prepared(g.nativeHls),
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.WebRtcGroup.name ? g.webRtc : (0, exports.Stopped)(g.webRtc);
    },
});
exports.Failed = exports.WebRtcGroup.registerState("Failed", {
    optionsApply: unloadDriver,
});
//#endregion
//# sourceMappingURL=webrtc.js.map